/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Container, Nav, Row } from 'react-bootstrap';
import Logo from '../img/Footer/logo.svg';
import Twitter from '../img/Footer/Twitter.svg';
import Telegram from '../img/Footer/Instagram.svg';
import Dribbble from '../img/Footer/Dribbble.svg';
import './Footer.scss';

export default function Footer({ scroll }) {
    return (
        <div className="footer-bg-color">
            <Container>
                <div className="footer pt-5">
                    <img src={Logo} alt="logo" className="d-block mx-auto" />
                    <Nav className="justify-content-center nav-paddin" activeKey="/home">
                        <Row className="text-center">
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#Home">Home</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#Features">Features</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item onClick={scroll}>
                                    <Nav.Link href="#Allocation">Allocation</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#Pools">Pools</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#Ecosystem">Ecosystem</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#RoadMap1">Roadmap</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view">
                                <Nav.Item>
                                    <Nav.Link href="#Partners">Partners</Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="nav-mobile-view-no-mb">
                                <Nav.Item>
                                    <Nav.Link href="#Team">Team</Nav.Link>
                                </Nav.Item>
                            </div>
                        </Row>
                    </Nav>
                </div>
                <div className="pt-4 pb-3">
                    <Row>
                        <Col xs={12} md={6} lg={6} className="rights-reserved">
                            <p className="text-white">&copy;2021 SolRazr. All rights reserved</p>
                        </Col>
                        <Col xs={12} md={6} lg={6} className="social-icons">
                            <div className="social-handles">
                                <Nav className="padding-footer" activeKey="/home">
                                    <Nav.Item>
                                        <Nav.Link
                                            href="https://twitter.com/Solrazr_App"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <img src={Twitter} alt="twitter" />
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            href="https://t.me/solrazr_app"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <img src={Telegram} alt="telegram" />
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            href="https://medium.com/@Solrazr_App"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <img src={Dribbble} alt="dribbble" />
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}
